<template>
  <div id="sw" />
</template>

<script>
export default {
  mounted() {
    document.addEventListener("swUpdated", this.showToast);
  },
  beforeDestroy() {
    document.removeEventListener("swUpdated", this.showToast);
  },
  methods: {
    showToast() {
      this.$toasted.show(this.$t("please_reopen_the_page"), {
        position: "top-center",
        action: [
          {
            text: this.$t("refresh"),
            onClick: (e, toastObject) => {
              this.reloadPage();
              toastObject.goAway(0);
            }
          },
          {
            text: this.$t("close"),
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        ]
      });
    },
    reloadPage() {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    }
  }
};
</script>
<style></style>
